import axios from "axios";
import { API_ENDPOINTS } from "../../constants/constants";
import { getAuthorizedHeaders } from "../../constants/utils"


const get = async (url: string, headers: object) => {
  return await axios.get(url, { headers })
}

const post = async (url: string, request: object, headers: object) => {
  return await axios.post(url, request, { headers })
}

const put = async (url: string, request: object, headers: object) => {
  return await axios.put(url, request, { headers });
}



export function authenticate(request: object) {
  let headers = {
    "Content-Type": "application/json; charset=utf-8",
    "Accept": "application/json"
  }
  return post(API_ENDPOINTS.IB_AUTH, request, headers)
}

export function handleLogout() {
  let authorizedHeader = getAuthorizedHeaders()
  return post(`${API_ENDPOINTS.LOGOUT}`, {}, authorizedHeader)
}

export function getTransactionDetails() {
  let authorizedHeader = getAuthorizedHeaders()
  return get(`${API_ENDPOINTS.GET_TRANSACTION_DETAILS}`, authorizedHeader)
}

export function submitTransactionConsent(request: object) {
  let authorizedHeader = getAuthorizedHeaders()
  return put(`${API_ENDPOINTS.SUBMIT_TRANSACTION_CONSENT}`, request, authorizedHeader)
}

export function getAccountBalance() {
  let authorizedHeader = getAuthorizedHeaders()
  return get(`${API_ENDPOINTS.GET_ACCOUNT_BALANCE}`, authorizedHeader)
}

export function getPaymentSummaryDetails() {
  let authorizedHeader = getAuthorizedHeaders()
  return get(`${API_ENDPOINTS.GET_PAYMENT_SUMMARY}`, authorizedHeader)
}

export function submitTncConsent(request: object) {
  let authorizedHeader = getAuthorizedHeaders()
  return post(`${API_ENDPOINTS.SUBMIT_TNC_CONSENT}`, request, authorizedHeader)
}

export function getProfileDetails() {
  let authorizedHeader = getAuthorizedHeaders()
  return get(`${API_ENDPOINTS.GET_PROFILE_DETAILS}`, authorizedHeader)
}

export function generateVerificationOtp() {
  let authorizedHeader = getAuthorizedHeaders()
  return post(`${API_ENDPOINTS.GENERATE_OTP}`, {}, authorizedHeader)
}

export function validateOtp(request: object) {
  let authorizedHeader = getAuthorizedHeaders()
  return post(`${API_ENDPOINTS.VALIDATE_OTP}`, request, authorizedHeader)
}

export function arcApprove() {
  let authorizedHeader = getAuthorizedHeaders()
  return post(`${API_ENDPOINTS.ARC_APPROVE}`, {}, authorizedHeader)
}

export function getAumMobile() {
  let authorizedHeader = getAuthorizedHeaders()
  return get(`${API_ENDPOINTS.AUM_MOBILE}`, authorizedHeader)
}

export function getInstitutionList(query: string) {
  let authorizedHeader = getAuthorizedHeaders()
  return post(`${API_ENDPOINTS.GET_INSTITUTION_LIST}${query}`, {}, authorizedHeader)
}

export function uploadDocuments(perfTxnId: string, documents: FormData) {
  let authorizedHeader = getAuthorizedHeaders()
  return post(`${API_ENDPOINTS.UPLOAD_DOCUMENTS}${perfTxnId}`, documents, authorizedHeader)
}

export function initiateUploadDocument(request: object) {
  let authorizedHeader = getAuthorizedHeaders()
  return post(`${API_ENDPOINTS.INITIATE_UPLOAD_DOC}`, request, authorizedHeader)
}

export function uploadDetails(request: object) {
  let authorizedHeader = getAuthorizedHeaders()
  return post(`${API_ENDPOINTS.UPLOAD_DETAILS}`, request, authorizedHeader)
}

export function resumeJourney() {
  let authorizedHeader = getAuthorizedHeaders()
  return post(`${API_ENDPOINTS.RESUME_JOURNEY}`, {}, authorizedHeader)

}
export function getTncContent() {
  let authorizedHeader = getAuthorizedHeaders()
  return get(`${API_ENDPOINTS.TNC_GET}`, authorizedHeader)
}

export function getUpdateContent() {
  let authorizedHeader = getAuthorizedHeaders()
  return get(`${API_ENDPOINTS.UPDATE_GET}`, authorizedHeader)
}

export function getTaxContent() {
  let authorizedHeader = getAuthorizedHeaders()
  return get(`${API_ENDPOINTS.TAX_GET}`, authorizedHeader)
}
